import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import {
    schemaLoanRequestResolver_GetBucketCounts,
    schemaUserResolver_GetAdvisersByBuckets,
} from 'cpool-tables/backend-resolvers';

import { ROUTE_ROLES } from '~/features/auth/constants/routeRoles';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';

const bucketsCountQueryOptions = getQueryOptions({
    aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
    resolverName: LOAN_REQUEST_RESOLVERS.getBucketCounts,
    schema: schemaLoanRequestResolver_GetBucketCounts,
});
const adviserBucketsQueryOptions = getQueryOptions({
    aggregateName: AGGREGATE_NAMES.USER,
    resolverName: 'getAdvisersByBuckets',
    schema: schemaUserResolver_GetAdvisersByBuckets,
});

export const Route = createFileRoute('/_app/management/distribution/')({
    beforeLoad: ({ location }) => {
        authoriseUser([...ROUTE_ROLES.LEAD_DISTRIBUTION], location);
        const content = 'ROUTE_TITLE.LEAD_DISTRIBUTION';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: async ({ context }) => {
        await Promise.all([
            context.queryClient.ensureQueryData(bucketsCountQueryOptions),
            context.queryClient.ensureQueryData(adviserBucketsQueryOptions),
        ]);
    },
});
